import { useLanguage } from '@/i18n/LanguageContext'

/** Visually hidden until focused (keyboard/screen-reader users only) — jumps past the nav straight to page content. WCAG 2.4.1 "Bypass Blocks". */
export function SkipLink() {
  const { t } = useLanguage()
  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[100] focus:rounded-pill focus:bg-accent-fire focus:px-4 focus:py-2 focus:text-sm focus:font-semibold focus:text-accent-fire-foreground"
    >
      {t('skip-to-content')}
    </a>
  )
}
